module.exports = __webpack_public_path__ + "static/media/Sanjay.2881459f.jpg";